/* global grecaptcha */
import { BehaviorSubject } from "rxjs";
import { LoginApi, UserDataApi } from "../api";
const SESSION_KEY = "user";

const currentUserSubject = new BehaviorSubject(null);
let currentData = null;

const UserDataService = {
  login: async (username, password, personalId) => {
    await UserDataService.getReCaptchaToken();

    const res = await LoginApi.login(username, password, personalId);
    return res;
    // success && UserDataService.setUser(username, token);

    // return { success, message };
  },

  remoteLogin: (token) => {
    return LoginApi.remoteLogin(token).then((res) => {
      if (res && res.success) {
        UserDataService.setUser(res.username, res.token);
        sessionStorage.setItem("zoomAnaliticsData", res.jsonData);
        sessionStorage.setItem("isGemelShowed", JSON.stringify(true));
        sessionStorage.setItem("hasLoan", JSON.stringify(res.hasLoan));
        sessionStorage.setItem("isFormsAuthorized", JSON.stringify(res.isFormsAuthorized));
        sessionStorage.setItem("isFormDigitalLoanAuthorized", JSON.stringify(res.isFormDigitalLoanAuthorized));
        sessionStorage.setItem("isProd", JSON.stringify(res.isProd));
        sessionStorage.setItem('isDigitalLoanAuthorized', JSON.stringify(res.isDigitalLoanAuthorized))

      }
      return { success: res ? res.success : false };
    });
  },

  logout: () => {
    sessionStorage.removeItem(SESSION_KEY);
    sessionStorage.clear();
    currentUserSubject.next(null);
  },

  renew: () => {
    if (UserDataService.isLoggedIn) {
      UserDataApi.renew()
        .then((res) => {
          if (res.success) {
            UserDataService.setUser(
              UserDataService.currentUser.username,
              res.token
            );
          }
        })
        .catch((reason) => UserDataService.logout());
      return true;
    }
    return false;
  },

  setUser: (username, token) => {
    const user = {
      username: username,
      token: token,
    };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(user));
    currentUserSubject.next(user);
  },

  get isLoggedIn() {
    return sessionStorage.getItem(SESSION_KEY) !== null;
  },

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  },

  get currentUser() {
    if (this.isJsonString(sessionStorage.getItem(SESSION_KEY))) {
      return sessionStorage.getItem(SESSION_KEY) !== null
        ? JSON.parse(sessionStorage.getItem(SESSION_KEY))
        : null;
    } else {
      UserDataService.logout();
      return null;
    }
  },

  get isUserMailingPopupNeeded() {
    if (
      sessionStorage.getItem("isUserMailingPopupNeeded") === undefined ||
      sessionStorage.getItem("isUserMailingPopupNeeded") === "undefined"
    )
      return null;
    return (
      JSON.parse(sessionStorage.getItem("isUserMailingPopupNeeded")) || null
    );
  },

  get isBlockedToAction() {
    if (
      sessionStorage.getItem("isBlockedToAction") === undefined ||
      sessionStorage.getItem("isBlockedToAction") === "undefined"
    )
      return null;
    return JSON.parse(sessionStorage.getItem("isBlockedToAction")) || null;
  },

  listen: (next) => currentUserSubject.subscribe(next),

  stopListen: (listener) => {
    listener.unsubscribe();
  },

  updateData: () => {
    return UserDataApi.get().then((x) => {
      if (x === null || x.status === 401) {
        UserDataService.logout();
        sessionStorage.removeItem("returnUrl");
      }
      const isMailingPopupOn = JSON.parse(
        sessionStorage.getItem("isMailingPopupOn")
      );
      const isUserMailingPopupNeeded =
        x.isUserMailingPopupNeeded && isMailingPopupOn;
      sessionStorage.setItem(
        "isUserMailingPopupNeeded",
        JSON.stringify(isUserMailingPopupNeeded)
      );
      sessionStorage.setItem(
        "isBlockedToAction",
        JSON.stringify(x.isBlockedToAction)
      );
      currentData = x;
    });
  },

  get data() {
    return currentData;
  },

  decodeToken: (token) => {
    try {
      const payload = token.split('.')[1];
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const json = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  },

  get children() {
    const user = UserDataService.currentUser;
    if (!user || !user.token) return [];
    const payload = UserDataService.decodeToken(user.token);
    if (!payload || !payload.MinorsAppointeCustomerId || !payload.MinorsAppointeJson) return [];
    try {
      const raw = JSON.parse(payload.MinorsAppointeJson) || [];
      return raw.map((child) => ({
        ...child,
        CustomerID: child.CustomerID ?? child.C?.[0]?.CustomerID,
      }));
    } catch (e) {
      return [];
    }
  },

  switchChild: (customerId) => {
    return LoginApi.switchChild(customerId).then((res) => {
      if (res && res.success) {
        const r = res.result;
        // Write token directly so updateData() below uses the new token,
        // but don't fire currentUserSubject yet (data isn't fresh yet).
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({ username: String(r.username), token: r.token }));
        sessionStorage.setItem("isBlockedToAction", JSON.stringify(res.isBlockedToAction));
        sessionStorage.setItem("customerId", JSON.stringify(res.customerId));
        sessionStorage.setItem("isGemelShowed", JSON.stringify(true));
        sessionStorage.setItem("zoomAnaliticsData", r.jsonData);
        sessionStorage.setItem("hasLoan", JSON.stringify(r.hasLoan));
        sessionStorage.setItem("sumUnViewed", JSON.stringify(r.sumUnViewed));
        sessionStorage.setItem("sumLetter", JSON.stringify(r.sumLetter));
        sessionStorage.setItem("margeMessageType", JSON.stringify(r.margeMessageType));
        sessionStorage.setItem("toDisplayCourseMargePopUp", JSON.stringify(r.toDisplayCourseMargePopUp));
        sessionStorage.setItem("showLetterPopup", JSON.stringify(r.displayLetterPopUp));
        sessionStorage.setItem("isMergePpopupShow", "0");
        sessionStorage.setItem("isShowPopup", "0");
        // Fetch user data with the new token so currentData is fresh.
        return UserDataService.updateData().then(() => {
          // Now fire the subscriber — AfterLoginLayout re-renders Header with new user name.
          currentUserSubject.next(UserDataService.currentUser);
          return { success: true };
        });
      }
      return { success: false };
    });
  },

  getReCaptchaToken: () =>
    new Promise((resolve, reject) => {
      grecaptcha.ready(function () {
        grecaptcha
          .execute(window.recaptchaKey, {
            action: "homepage",
          })
          .then((res) => resolve({ token: res }));
      });
    }),
};

currentUserSubject.next(UserDataService.currentUser);

export default UserDataService;
